<template>
  <v-dialog v-model="show" max-width="400" :persistent="isProcessing">
    <v-card v-if="purchaseComplete">
      <v-card-title class="headline">{{productName}}</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="text-center">
        <p class="headline">{{amount}}</p>
        <p class="headline teal--text">Thank you. Your payment has been accepted.</p>
        <p><v-icon color="teal">check_circle</v-icon></p>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="teal" depressed dark @click.native="show = false">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline">Buy {{productName}}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p class="headline teal--text text-center">Payment Amount: {{amount}}</p>
        <div class="subheading mb-2">Credit or debit card</div>
        <div ref="card" id="card"></div>
        <span class="caption mb-2">* We never store your card number or CVC number.</span>
        <v-alert :value="test" color="warning" icon="priority_high" outlined>Server: using Stripe test key.</v-alert>
        <v-alert :value="isTest" color="warning" icon="priority_high" outlined>Client: using Stripe test key.</v-alert>
        <div class="red--text">{{paymentError}}</div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="teal" depressed dark @click.native="submit" block :loading="isProcessing">
          Buy
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// test: pk_test_tT1xwbJZpid9L9OUUBBkMBfx
// prod: pk_live_xNpUYYjuxIFBmjsZ6sVRiy0q
import axios from 'axios'

// let dev = true
// eslint-disable-next-line
// let planIdEbookDomesticViolence = dev ? 'EmkMxb2nR7OTEj' : ''
// eslint-disable-next-line
let stripeKey = process.env.VUE_APP_STRIPE_KEY//dev ? 'pk_test_tT1xwbJZpid9L9OUUBBkMBfx' : 'pk_live_xNpUYYjuxIFBmjsZ6sVRiy0q'
// eslint-disable-next-line
let serverURL = process.env.VUE_APP_LIMPID_PAY_URL//dev ? 'localhost:6544' : 'api.limpidpay.com'
const appId = process.env.VUE_APP_LIMPID_PAY_APPID

// eslint-disable-next-line
let stripe = Stripe(stripeKey)
const elements = stripe.elements()

export default {
  data: () => ({
    card: null,
    paymentError: '',
    isProcessing: false,
    purchaseComplete: false
  }),
  props: {
    dialogVisible: Boolean,
    test: Boolean,
    firstName: String,
    lastName: String,
    email: String,
    stripePriceId: String,
    productImageURL: {
      type: String,
      default: null
    },
    productName: {
      type: String,
      default: 'product'
    },
    amount: {
      type: String,
      default: 'AU$0.0'
    },
    didCancel: Function,
    didCompletePurchase: Function
  },
  computed: {
    show: {
      get () {
        return this.dialogVisible
      },
      set (value) {
        this.paymentError = ''
        if (this.card) {
          this.card.clear()
        }
        this.$emit('input', value)
      }
    },
    isTest () {
      return stripeKey.includes('_test_')
    }
  },
  updated () {
    console.log('before update')
    if (this.dialogVisible && !this.card) {
      var style = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
      this.card = elements.create('card', { hidePostalCode: true, style: style })
      this.card.mount(this.$refs.card)
      var that = this
      // Handle real-time validation errors from the card Element.
      this.card.addEventListener('change', function (event) {
        if (event.error) {
          that.paymentError = event.error.message
        } else {
          that.paymentError = ''
        }
      })
    }
  },
  methods: {
    cancel () {
      this.$props.didCancel()
    },
    submit () {
      const that = this
      this.paymentError = ''
      this.isProcessing = true
      stripe.createToken(this.card).then(function (result) {
        if (result.error) {
          that.paymentError = result.error.message
          that.$forceUpdate()
          that.isProcessing = false
        } else {
          console.log(result)
          that.stripeTokenHandler(result.token)
        }
      })
    },
    stripeTokenHandler (token) {
      console.log('stripe token handler')
      console.log(token.id)
      console.log(token)
      const that = this
      const payload = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        stripePriceId: this.stripePriceId,
        token: token
      }
      axios({
        method: 'post',
        url: `${serverURL}/v1/transactions/${appId}`,
        data: payload
      }).then((resp) => {
        console.log(resp)
        that.isProcessing = false
        that.purchaseComplete = true
        this.card.clear()
        that.didCompletePurchase(this.stripePriceId)
      }).catch((error) => {
        console.log(error)
        that.paymentError = error.message
        var errorReponse = { code: 0, title: 'Unkown API error', message: 'Unkown API error' }
        if (error.response && error.response.data && error.response.data.status === 'error') {
          errorReponse = error.response.data.error
        } else {
          errorReponse.title = error.message
          errorReponse.message = error.message
        }
        that.paymentError = errorReponse.message
        that.isProcessing = false
      })
    }
  },
  beforeDestroy () {
    console.log('beforeDestroy')
    if (this.card) {
      this.card.unmount()
      this.card.destroy()
    }
    // stripe.instance = null
    // stripe.elements = null
    // card = null
  // }
  }
}
</script>

<style scoped>
.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}
.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}
.StripeElement--invalid {
  border-color: #fa755a;
}
.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
